import { IApp } from 'common/core/interfaces/app'
import { parseAbilities } from 'common/core/models/Ability/helpers'

import { ResponseData } from 'initAppAPI'

export const parseInitApp = (data: Partial<ResponseData>): Partial<IApp> => {
  const abilitiesKey = 'app.currentAccount.abilities'
  const walletKey = 'app.currentAccountWallet'

  const app: Partial<IApp> = Object.entries(data)
    .filter(([key]) => key.startsWith('app.') && ![walletKey, abilitiesKey].includes(key))
    .reduce(
      (result, [key, value]) => {
        result[key.replace('app.', '')] = value
        return result
      },
      {} as Record<string, unknown>,
    )

  if (app.currentAccount) {
    app.currentAccount.abilities = parseAbilities(data[abilitiesKey])
  }

  app.accountsCount = data['data.accounts_count'] ?? 0

  return app
}
